.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  align-items: flex-end;
  justify-content: space-between;
}

.start {
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  gap: var(--space-2);
  align-items: flex-end;
  min-inline-size: 0;
}

.start > * {
  min-inline-size: 10rem;
}

/* Toggles and buttons keep their own width: stretched, a switch drifts away from its label. */
.start > :is(a, button),
.start > :has([role="switch"], [role="checkbox"]) {
  min-inline-size: auto;
}

.end {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  align-items: center;
}
